var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"dropdown",style:(_vm.displayManage)},[_c('div',{staticClass:"dropdown-content"},[_c('p',{staticClass:"option cursor-pointer py-auto m-0"},[_c('img',{attrs:{"src":_vm.Image,"alt":""}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }